import styled from "styled-components";
import { palette } from "styled-theme";
import { isIE11 } from "@utils/helpers/browserHelper";
import { withFilteredProps } from "@components/withFilteredProps/withFilteredProps";

const defaultBaseStrokeWidth = 10;
const getStrokeWidth = props => props.strokeWidth ?? defaultBaseStrokeWidth;

export const _CheckMarkSvg = styled.svg`
  display: block;   
  margin: 0 auto; 
  fill: none;
  padding: ${(props) => getStrokeWidth(props) / (defaultBaseStrokeWidth * 2)}px;
  overflow: visible;
  
  .circles {
    transform-origin: 50% 50%;
    animation: rotate 2s linear infinite;
    animation-fill-mode: forwards;
  }
  
  &.checked .circles {
    animation-play-state: paused;
    fill: rgba(255, 255, 255, 0);
  }
  
  .circles circle {
    stroke-width: ${(props) => getStrokeWidth(props)}px;
  }
  
  .circles .color-circle {
    stroke-dasharray: 80, 2000;
    stroke: ${palette("checkMark", 0)};
  }
  
  path {
    stroke-width: ${(props) => getStrokeWidth(props) * 1.15}px;
    stroke-dasharray: 0, 200;
    stroke: ${palette("checkMark", 1)};
  }
  
  &.checked .circles .color-circle {
    animation: fillCircle 1s ease-in;
    animation-fill-mode: forwards;
  }
  
  &.checked path {
    animation: fillTick 1s linear;
    animation-fill-mode: forwards;
    animation-delay: 1s;
  }
  
  ${isIE11 && `
    animation: opacityFlash 1s linear infinite;
    
    .circles .color-circle {
      stroke-dasharray: 600, 2000 !important;
    }
    
    .circles .color-circle {
      stroke-width: 0;
    }
    
    &.checked {
      animation: none;
    }

    &.checked path {
      stroke-dasharray: 120, 200 !important;
    }
    
    &.checked .circles .color-circle {
      stroke-width: 2;
    }
  `}
  
  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
  
  @keyframes rotateThenStop {
    100% {
      transform: rotate(360deg);
    }
  }
  
  @keyframes fillTick {
    100% {
      stroke-dasharray: 300, 200;
    }
  }
  
  @keyframes fillCircle {
    80% {
      stroke-dasharray: 600, 2000;
    }
    100% {
      fill: ${palette("checkMark", 2)};
      stroke: ${palette("checkMark", 2)};
      stroke-dasharray: 600, 2000;
    }
  }
  
  @keyframes opacityFlash {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0.2;
    }
    50% {
      opacity: 1;
    }
  }
`;

export const CheckMarkSvg = withFilteredProps(_CheckMarkSvg);